export const getCCWeeklyTableColumns = () =>
	Object.freeze([
		'Date From',
		'Date To',
		'Confirmed',
		'Resigned After',
		'Resigned After %',
		'Sent Immediately',
		'Sent Anytime',
		'To Send',
		'Delivered',
		'Delivered %',
		'Online Payment',
		'Paid',
		'Leads',
	]);
